// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchSeoProgrammaticContent_wrapper__zAGfy"};